export default __webpack_public_path__ + "static/media/Benefits2.450e8feb.bin";